import styled from 'styled-components';
import { LinkId } from '../../AnalyticsContext/LinkId';
import { ThemeColours } from '../../styles/ThemeColours';
import { PRESSABLE } from '../../styles/constants';
import { Link } from '../Link';
import { IconFacebook } from '../icons/IconFacebook';
import { IconLinkedIn } from '../icons/IconLinkedIn';
import { IconTwitter } from '../icons/IconTwitter';

export const SocialLinks = () => (
  <View>
    <StyledLink trackingId={LinkId.FOOTER} to="https://twitter.com/healthengine" title="Twitter">
      <Icon as={IconTwitter} />
    </StyledLink>

    <StyledLink
      trackingId={LinkId.FOOTER}
      to="https://www.facebook.com/HealthEngine/"
      title="Facebook"
    >
      <Icon as={IconFacebook} />
    </StyledLink>

    <StyledLink
      trackingId={LinkId.FOOTER}
      to="https://au.linkedin.com/company/healthengine"
      title="LinkedIn"
    >
      <Icon as={IconLinkedIn} />
    </StyledLink>
  </View>
);

export const View = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledLink = styled(Link)`
  ${PRESSABLE};
  margin-right: 16px;

  &:hover {
    color: ${ThemeColours.mono600};
  }
`;

const Icon = styled.svg`
  fill: ${ThemeColours.mono600};
  height: 20px;
  width: 20px;
`;
